import React from 'react';
import './Header.css';
import { FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

const Header = ({ isMobile, isSidebarOpen, toggleSidebar, user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Çıkış yapılamadı:', error);
    }
  };

  return (
    <header className="app-header">
      <div className="header-section left">
        {isMobile && (
          <button className="menu-toggle" onClick={toggleSidebar}>
            ☰
          </button>
        )}
      </div>

      <div className="header-section center">
        <div
          className="header-title"
          onClick={() => navigate('/')}
          style={{ cursor: 'pointer' }}
        >
          Süzme Sayaç
        </div>
      </div>
      <div className="header-section right">
        {user && (
          <>
            <span className="username">{user.displayName}</span>
            <button className="logout-button" onClick={handleLogout}>
              <FaSignOutAlt /> <span>Çıkış</span>
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
